export type ShareData = {
  text: string;
  title: string;
  url: string;
  files?: File[];
};

export function canUseNativeShare(data: ShareData) {
  return (
    typeof navigator.canShare === 'function' &&
    navigator.canShare(data) &&
    window.innerWidth < 768 // Only on mobile
  );
}

export function nativeShare(data: ShareData) {
  return navigator.share(data).catch((err) => console.log(err));
}
